import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEdit, FaTrash } from "react-icons/fa";
import {
  getPlanList,
  deletePlan,
  updatePlanStatus,
} from "../../redux/services/SubscriptionServices/Subscription.Services";
import { openModal } from "../../redux/features/modalSlice";
import Pagination from "../../common/Pagination";
import { errorToast } from "../../Utils/toast";
import Search from "../../common/Search";
import { useDispatch } from "react-redux";

function AllPlanList() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [tableLoading, setTableLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [subscription, setSubscription] = useState([]);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(100);
  const [totalLeads, setTotalLeads] = useState(0);
  const [totalPages, setTotalPages] = useState(1);

  const fetchSubscriptionList = async (pageNo = 1) => {
    try {
      setTableLoading(true);
      const payload = {
        
        search, page: pageNo, per_page: limit };
      const res = await getPlanList(payload);
      const list = Array.isArray(res?.data) ? res.data : [];
      setSubscription(list);
      setPage(res?.current_page ?? 1);
      setTotalPages(res?.last_page ?? 1);
      setTotalLeads(res?.total ?? 0);
    } catch (error) {
      console.log(error);
      errorToast("Failed to load subscription plans");
      setSubscription([]);
    } finally {
      setTableLoading(false);
    }
  };

  useEffect(() => {
    fetchSubscriptionList(1);
    // eslint-disable-next-line
  }, [limit, search]);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages && !tableLoading) {
      setPage(newPage);
      fetchSubscriptionList(newPage);
    }
  };

  const formatPrice = (val) => {
    if (val === null || val === undefined || val === "") return "-";
    return `₹${Number(val).toLocaleString("en-IN")}`;
  };

  return (
    <div>
      <div className="d-flex align-items-center justify-content-between page-header-breadcrumb">
        <div className="title_member">
          <h4>Plan List</h4>
        </div>
        <div className="d-flex flex-wrap gap-2 justify-content-end">
<button
  className="add-btn"
  onClick={() => navigate("/add-plan")}
>
  + Add Plan
</button>
        </div>
      </div>

      <div className="main_page">
        {(totalLeads > 0 || search) && (
          <div className="d-flex justify-content-end align-items-center mx-2 mb-2">
            <Search
              search={search}
              placeholder="Search Plan..."
              onSearch={(value) => {
                setSearch(value);
                setPage(1);
              }}
            />
          </div>
        )}

        <div className="st-wrapper-card text-center">
          <div className="st-table-responsive">
            <table className="table st-custom-table align-middle mb-0">
              <thead>
                <tr>
                  <th>Sr.No</th>
                  <th>Plan Name</th>
                  <th>Module</th>
                  {/* <th>Category</th> */}
                  <th>Price</th>
                  <th>ai_call_limit</th>
                  {/* <th>Duration</th> */}
                  {/* <th>Is Paid</th> */}
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {tableLoading ? (
                  <tr>
                    <td colSpan="9" className="text-center py-3">
                      <div className="spinner-border text-primary"></div>
                    </td>
                  </tr>
                ) : subscription.length > 0 ? (
                  subscription.map((item, index) => (
                    <tr key={item.id}>
                      <td>{(page - 1) * limit + index + 1}</td>

                      <td className="text-start">
                        <div className="fw-bold">{item?.name || "-"}</div>
                        {item?.description && (
                          <small className="text-muted">
                            {item.description}
                          </small>
                        )}
                      </td>

                      <td>{item?.module?.name || "-"}</td>

                      {/* <td>
                        {item?.category?.name ? (
                          <span className="badge bg-info text-dark">
                            {item.category.name}
                          </span>
                        ) : (
                          "-"
                        )}
                      </td> */}

                      <td className="fw-bold text-success">
                        {formatPrice(item?.price)}
                      </td>
                      <td className="fw-bold text-success">
                        Seconds ( {item?.ai_call_limit} )
                      </td>
{/* 
                      <td>
                        {item?.duration_days
                          ? `${item.duration_days} days`
                          : "-"}
                      </td> */}

                      {/* <td>
                        {item?.module?.is_paid === 1 ? (
                          <span className="badge bg-success">Yes</span>
                        ) : (
                          <span className="badge bg-secondary">No</span>
                        )}
                      </td> */}

                      <td>
                        <div className="city-status-switch">
                          <input
                            type="checkbox"
                            id={`status-${item.id}`}
                            className="city-status-input"
                            checked={item.status == 1}
                            onChange={() =>
                              dispatch(
                                openModal({
                                  type: "change-toggle-status",
                                  title: "Change Status",
                                  data: {
                                    id: item.id,
                                    status:
                                      item.status === 1 ? "Active" : "Inactive",
                                    statusFunction:
                                      updatePlanStatus,
                                    onSuccess: () =>
                                      fetchSubscriptionList(page),
                                  },
                                })
                              )
                            }
                          />
                          <label
                            htmlFor={`status-${item.id}`}
                            className="city-status-label"
                          >
                            <span className="city-status-ball"></span>
                            <span className="city-status-text">
                              {item.status === 1 ? "Active" : "Inactive"}
                            </span>
                          </label>
                        </div>
                      </td>

                      <td className="text-center">
                        <div className="d-flex align-items-center justify-content-center gap-1">
                          {/* ✅ VIEW */}
                          <button
                            className="st-action-btn st-view-btn"
                            title="View"
                            onClick={() =>
                              navigate(`/view-plan/${item.id}`)
                            }
                          >
                            <FaEye />
                          </button>

                          {/* ✅ EDIT */}
                          <button
                            className="st-action-btn st-edit-btn"
                            title="Edit"
                            onClick={() =>
                              navigate(`/update-plan/${item.id}`)
                            }
                          >
                            <FaEdit />
                          </button>

                          {/* DELETE — modal is fine here */}
                          <button
                            className="st-action-btn st-delete-btn"
                            title="Delete"
                            onClick={() =>
                              dispatch(
                                openModal({
                                  type: "delete-plan",
                                  title: "Delete Plan",
                                  data: {
               id: item.id,
        name: item.name,
                                   
                                    deleteFunction: deletePlan,
                                    refreshData: fetchSubscriptionList,
                                  },
                                })
                              )
                            }
                          >
                            <FaTrash />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="9" className="text-center py-3">
                      No subscription plans found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            {totalPages > 1 && (
              <div className="d-flex justify-content-end mt-3">
                <Pagination
                  page={page}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default AllPlanList;